var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-home"},[(!_vm.isExperienceStarted && _vm.isNewVisit)?_c('home-intro',{on:{"startExperience":_vm.startExperiencePage}}):_vm._e(),_c('home-navigation'),_c('home-scene')],1)}
var staticRenderFns = []

export { render, staticRenderFns }